export default __webpack_public_path__ + "static/media/hospital.d330695b.png";